var BaseMoveFnMixin = require('./baseMoveFnMixin'),
    DragHelper = require('./dragHelper');


module.exports = {

    moveStart: function( x, y, e ) {

        var dragHelperOptions = {
            canvasBounds: this.channel.request('canvasContainerRel'),
            dragOpacity: 0.6,
            isTransformedShape: this.shapeModel.shapeViewSupportsTransforms(),
            preventDragOffCanvas: !this.shapeModel.allowDragOffCanvas()
        };

        if ( this.shapeModel.shapeViewSupportsTransforms() ) {

            // TODO: are these necessary now - can we just use the model ?
            var shapePageTransformModel = this.shapeModel.getTransformModel().getPageModel();

            _.extend( dragHelperOptions, {
                pageScale: shapePageTransformModel.getScale(),
                pageRotation: shapePageTransformModel.getRotation(),
                pageTransform: shapePageTransformModel.getTransform()
            });

        }

        this.dragHelper = new DragHelper( dragHelperOptions );

        BaseMoveFnMixin.moveStart.call( this, x, y, e, this.dragHelper );

        this.shapeModel.uiModel.set( 'isMoving', true );

    },
    moveMove: function( dx, dy, x, y, e ) {

        /* ( now sets this.dx, this.dy ) */
        BaseMoveFnMixin.moveMove.call( this, dx, dy, x, y, e, this.dragHelper, function() {

            if ( !this.shapeUI.get('isMoving') || this.shapeUI.get('isResizing') )
                return;

            // was old hook -- now not used so put back here -- could override again at the shape level --
            // TODO: prob want another place to override PUT BACK THE OLD FN
            // maybe just check for existance of a transform fn ...?
             if ( !this.dragHelper.isTransformedShape ) {
                 this.el.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy );
             } else {
                 this.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy ); // ( assumes the transform function uses the page level transform ) !!
             }

            var getBox = function( cb ) { /* want to perf. calc prior to using it to base other moves */
                    var box = this.el.getBBox();
                    cb.call(this, box);
                },
                triggerMove = function( box ) {
                    this.trigger( 'shape.move', box, this.dragHelper.dx, this.dragHelper.dy ); // want diff event
                };

            getBox.call( this, triggerMove );

        } );


    },
    moveEnd: function(e) {

        BaseMoveFnMixin.moveEnd.call( this, e, this.dragHelper );

        if ( this.dragHelper.isTransformedShape ) {

            // needs to have different fn's depending on path or x,y -- TODO: make it overwritable
            // would need to loop through the elements in the set for path/not path ....
            this.el.attr({
                x:  this.el.attr('x') + this.dragHelper.invmDx,
                y: this.el.attr('y') + this.dragHelper.invmDy
            });


            var shapeTransformModel = this.shapeModel.getTransformModel();
            shapeTransformModel.setOx( this.el.attr('x') );
            shapeTransformModel.setOy( this.el.attr('y') );
            this.transform();

            this.trigger( 'shape.selectBox.resetPath', this.el.getBBox(), true );


        } else {

            // quick fix for existing design which did assume all paths (would need to bake the transform)
            // but now don't do for shapes that aren't paths -- graphic stamps are images ...
            this.el.isPath() && this.el.bakeTransform();

        }


        this.shapeUI.set({isMoving: false});

        this.trigger('shape.moveEnd');

        // Now only holds primitives
        delete this.dragHelper;


    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/moveFns/shapeViewMoveFns.js
 ** module id = 189
 ** module chunks = 0
 **/